import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { useGetReviewDetailsQuery } from "../../../../store/services/reviewService";
import moment from "moment";
import TableLayout from "../../../../components/TableLayout";
import {CstmPagination} from "../../../../components/Common/Common"

const ReviewDetail = () => {
  const { id } = useParams();
  const { data: User, error, isLoading } = useGetReviewDetailsQuery(id);

  if (error) {
    return <div>Something went wrong</div>;
  }

  console.log("User", User);

  const column = [
   
    {
      head: "Question",
      accessor: "question",
      component: (item, key, arr) => (
        <p className="m-0 themeBlue fw-sbold">{item?.questionId?.questionText}</p>
      ),
    },
    {
      head: "Note",
      accessor: "note",
      component: (item, key, arr) => (
        <p className="m-0 themeBlue fw-sbold">{item?.note}</p>
      ),
    },
    {
      head: "Response",
      accessor: "response",
      component: (item, key, arr) => (
        <p className="m-0 themeBlue fw-sbold">{item?.response}</p>
      ),
    },
  
    
    
   
    
  ];
  const showOptionValue = (item) => {
    if (!item) return '';
  
    const { questionId, response } = item;
    const options = questionId?.type === "scale" ? questionId?.scaleOptions : questionId?.options;
  
    if (!options?.length) return response;
  
    if (isNaN(response)) return response;
  
    const index = Number(response) - 1;
    return options[index] ?? response;
  };
  

  return (
   
    <section className="userDetail py-3 position-relative">
      <Container>
        <Row>
          <Col lg="12">
            <div className="d-flex align-items-center gap-2">
              <Link to="/reviews" className="border d-flex align-items-center p-2 rounded">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 10 16" fill="none">
                  <path
                    d="M8.64707 0.473344C8.55514 0.381188 8.44594 0.308072 8.32572 0.258184C8.20549 0.208296 8.07661 0.182617 7.94644 0.182617C7.81628 0.182617 7.68739 0.208296 7.56717 0.258184C7.44694 0.308072 7.33774 0.381188 7.24582 0.473344L0.667065 7.05209C0.593675 7.12533 0.53545 7.21233 0.495723 7.3081C0.455996 7.40387 0.435547 7.50654 0.435547 7.61022C0.435547 7.7139 0.455996 7.81657 0.495723 7.91234C0.53545 8.00811 0.593675 8.0951 0.667065 8.16834L7.24582 14.7471C7.63373 15.135 8.25915 15.135 8.64707 14.7471C9.03498 14.3592 9.03498 13.7338 8.64707 13.3458L2.9154 7.60626L8.65498 1.86668C9.03498 1.48668 9.03498 0.853344 8.64707 0.473344Z"
                    fill="#1E232C"
                    stroke="#1E232C"
                    strokeWidth="0.2"
                  />
                </svg>
              </Link>
              <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">Review Details</h4>
            </div>
          </Col>

          <Col lg="12" className="my-2">
            <div className="formWrpper px-lg-5 p-md-4 p-3 rounded" style={{ background: "#EEEEEE" }}>
              {isLoading && (
                <div className="text-center">
                  <div className="spinner-border text-dark" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              )}

              {!isLoading && User?.data && (
                <>
                  
                  <Table striped bordered hover className="mt-3">
                    <thead>
                      <tr>
                        <th className="text-muted fw-bold">Sr.No.</th>
                        <th className="text-muted fw-bold">Question</th>
                        <th className="text-muted fw-bold">Answer</th>
                        <th className="text-muted fw-bold">Note</th>
                      </tr>
                    </thead>
                    <tbody>
                      {User?.data?.responses?.map((item, index) => (
                        <tr key={index}>
                          <td className="m-0 themeBlue fw-sbold">{index + 1}</td>
                          <td className="m-0 themeBlue fw-sbold">{item?.questionId?.questionText || "N/A"}</td>
                          <td className="m-0 themeBlue fw-sbold">{item?.response ? showOptionValue(item) : "N/A"}</td>
                          <td className="m-0 themeBlue fw-sbold">{item?.note || "N/A"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </>
              )}
            </div>
          </Col>
          
        </Row>
      </Container>
    </section>
  );
};

export default ReviewDetail;



// import React from "react";
// import { Col, Container, Form, Row } from "react-bootstrap";
// import { Link, useParams } from "react-router-dom";
// import i1 from "../../../../Assets/images/authBg.png";
// import { useGetUserDetailsQuery } from "../../../../store/services/userService";
// import { useGetReviewDetailsQuery } from "../../../../store/services/reviewService";
// import moment from "moment";

// const ReviewDetail = () => {
//   // get id from url
//   const { id } = useParams();
//   // const { data: User, error, isLoading } = useGetUserDetailsQuery(id);
//   const { data: User, error, isLoading } = useGetReviewDetailsQuery(id);

//   console.log("reviews ======>", User);

//   if (error) {
//     return <div>Something went wrong</div>;
//   }

//   return (
//     <section className="userDetail py-3 position-relative">
//       <Container>
//         <Row>
//           <Col lg="12">
//             <div className="d-flex align-items-center gap-10">
//               <Link
//                 to="/reviews"
//                 className="border d-flex align-items-center p-2 rounded"
//               >
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="12"
//                   height="12"
//                   viewBox="0 0 10 16"
//                   fill="none"
//                 >
//                   <path
//                     d="M8.64707 0.473344C8.55514 0.381188 8.44594 0.308072 8.32572 0.258184C8.20549 0.208296 8.07661 0.182617 7.94644 0.182617C7.81628 0.182617 7.68739 0.208296 7.56717 0.258184C7.44694 0.308072 7.33774 0.381188 7.24582 0.473344L0.667065 7.05209C0.593675 7.12533 0.53545 7.21233 0.495723 7.3081C0.455996 7.40387 0.435547 7.50654 0.435547 7.61022C0.435547 7.7139 0.455996 7.81657 0.495723 7.91234C0.53545 8.00811 0.593675 8.0951 0.667065 8.16834L7.24582 14.7471C7.63373 15.135 8.25915 15.135 8.64707 14.7471C9.03498 14.3592 9.03498 13.7338 8.64707 13.3458L2.9154 7.60626L8.65498 1.86668C9.03498 1.48668 9.03498 0.853344 8.64707 0.473344Z"
//                     fill="#1E232C"
//                     stroke="#1E232C"
//                     stroke-width="0.2"
//                   />
//                 </svg>
//               </Link>
//               <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
//                 Reviews details
//               </h4>
//             </div>
//           </Col>
//           <Col lg="12" className="my-2">
//             <div
//               className="formWrpper px-lg-5 p-md-4 p-3 rounded"
//               style={{ background: "#EEEEEE" }}
//             >
//               {isLoading && (
//                 <div className="text-center">
//                   <div className="spinner-border text-dark" role="status">
//                     <span className="sr-only">Loading...</span>
//                   </div>
//                 </div>
//               )}
//               {!isLoading && User?.data && (
//                 <Row className="justify-content-between">
              
//                   <Col md={6} className="my-2">
//                     <ul className="list-unstyled ps-0 mb-0 notLastBorder pe-lg-3">
//                       <li className="py-3 d-flex align-items-center gap-10">
//                         <p className="m-0 themeBlue fw-sbold w-25">
//                           User Name:
//                         </p>
//                         <h6 className="m-0 text-muted fw-bold w-50">
//                           {User?.data?.name}
//                         </h6>
//                       </li>
//                       <li className="py-3 d-flex align-items-center gap-10">
//                         <p className="m-0 themeBlue fw-sbold w-25">Email:</p>
//                         <h6 className="m-0 text-muted fw-bold w-50">
//                           {User?.data?.email}
//                         </h6>
//                       </li>
                      
//                       <li className="py-3 d-flex align-items-center gap-10">
//                         <p className="m-0 themeBlue fw-sbold w-25">
//                           Phone Number:
//                         </p>
//                         <p className="m-0 text-muted fw-bold w-50">
//                           {User?.data?.mobileNumber}
//                         </p>
//                       </li>
//                     </ul>
//                   </Col>
//                   <Col md={6} className="my-2">
//                     <ul className="list-unstyled mb-0 notLastBorder ps-lg-3">
//                       <li className="py-3 d-flex align-items-center gap-10">
//                         <p className="m-0 themeBlue fw-sbold w-25">
//                           Created at:
//                         </p>
//                         <h6 className="m-0 text-muted fw-bold w-50">
//                           {moment(User?.data.createdAt).format("DD/MM/YYYY")}
//                         </h6>
//                       </li>
//                       <li className="py-3 d-flex align-items-center gap-10">
//                         <p className="m-0 themeBlue fw-sbold w-25">Status:</p>
//                         <h6 className="m-0 text-muted fw-bold w-50 text-capitalize">
//                           {User?.data?.status}
//                         </h6>
//                       </li>
//                     </ul>
//                   </Col>
//                 </Row>
//               )}
//             </div>
//           </Col>
//         </Row>
//       </Container>
//     </section>
//   );
// };

// export default ReviewDetail;
